import React, { useEffect, useState } from 'react';
import { IRouteDetailsImage } from '../../../../../sp-types/routeDetailsType';
import { getFileByUrl } from '../../../../../sp-firebase/storageFB';

export const RouteDetailsImage: React.FC<IRouteDetailsImage> = ({ imageUrl }) => {
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    const fetchUrl = async () => {
      const fetchedUrl = await getFileByUrl(imageUrl);
      setUrl(fetchedUrl || '');
    };

    fetchUrl();
  }, [imageUrl]);

  return url ? <img className="max-h-[20rem]" src={url} alt="Route Detail" /> : <div></div>;
};
